import { useMemo } from 'react'
import SmartMateriaUITable from '../../../generic/SmartMateriaUITable'

const MosSmartTable = (props) => {
  const { columns, showSearchHeader, toolbarDisplay = 'none', hideExport = false, toolbarHeight = undefined, compactHeader = false, searchPosition = 'right' } = props
  const tablePageSize = useMemo(() => {
    if (props.tablePageSize !== undefined) {
      return props.tablePageSize
    }
    return props.pageable ? -1 : Number.MAX_SAFE_INTEGER
  }, [props.pageable, props.tablePageSize])

  const finalColumns = useMemo(() => {
    if (showSearchHeader) {
      return columns
    }
    return columns.map((column) => { return { ...column, search: null } })
  }, [columns, showSearchHeader])

  return <SmartMateriaUITable {...props} hideExport={hideExport} toolbarDisplay={toolbarDisplay} toolbarHeight={toolbarHeight} compactHeader={compactHeader} searchPosition={searchPosition} tablePageSize={tablePageSize} columns={finalColumns} />
}

export default MosSmartTable
